import styled from "styled-components";

import {
  DATA_E2E_KEY,
  DRAWER_FOOTER_HEIGHT,
  IStyledAttributes,
} from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const MobilFiltersFooterStyled = styled.footer.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "mobil-filters-footer",
})`
  border-top: 1px solid ${greyMui._300};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
  height: ${DRAWER_FOOTER_HEIGHT}px;
  gap: 12px;
`;
